import { compact } from 'lodash/fp'
import _ from 'lodash'

import { LegalConditionDisclaimerMarketConductNoAddtionalContract } from 'quick-quote/v2/components/disclaimers'
import ProfileSnapshot from 'quick-quote/product-common/benefit-illustration/components/profile-summary/profile-snapshot'
import ProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits'
import { TaxConsentDeductionS7Benefit } from 'quick-quote/product-common/benefit-illustration/components/tax-consent-deduction-benefit'
import PolicyValueTable from 'quick-quote/v2/components/benefit-illustration/policy-values/layout-with-cash-drop-no-rider/policy-value-table'
import { getProfileSnapshot } from 'quick-quote/product-common/benefit-illustration/components/profile-summary/selectors'
import { getProductBenefits } from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/selectors'
import { getPolicyValueTableBenefits } from 'quick-quote/v2/components/benefit-illustration/policy-values/layout-with-cash-drop/selectors'
import { getTaxDeduction } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getLegalConditionDisclaimer } from 'quick-quote/v2/components/disclaimers/selectors'
import MESSAGES from 'core/data-model/constants/bi-messages'

const _summaryHeaderWithCode = ({ displayProduct }) => {
  const name = _.get(displayProduct, 'displayName', '')
  const riderPlanCode = _.get(displayProduct, 'basicPlanCode', '')
  return `${name} (${riderPlanCode})`
}

const _summaryHeader = ({ displayProduct }) => MESSAGES.CONTRACTS + _.get(displayProduct, 'nameThai')

export const getSections = (state) => {
  return compact([
    {
      component: ProfileSnapshot,
      props: {
        ...getProfileSnapshot(state),
        profileSummaryHeader: _summaryHeaderWithCode,
        summaryTableHeader: _summaryHeader,
      },
    },
    {
      component: ProductBenefits,
      props: {
        ...getProductBenefits(state),
      },
    },

    {
      component: PolicyValueTable,
      props: {
        ...getPolicyValueTableBenefits(state),
      },
    },
    {
      component: TaxConsentDeductionS7Benefit,
      props: {
        taxDeduction: getTaxDeduction(state),
      },
    },
    {
      component: LegalConditionDisclaimerMarketConductNoAddtionalContract,
      props: {
        ...getLegalConditionDisclaimer(state),
      },
    },
  ])
}

export const getMenus = (state) => {
  return compact([
    {
      text: MESSAGES.SUMMARY_OF_MAIN_CONTRACTS,
      id: 'profile-summary',
      isSub: false,
    },
    {
      text: 'รายละเอียดของสัญญาหลัก',
      id: 'product-benefits',
      isSub: false,
    },
    {
      text: MESSAGES.POLICY_VALUE_TABLE,
      id: 'policy-value',
      isSub: false,
    },
    {
      text: MESSAGES.LEGAL_DISCLAIMER,
      id: 'legal-disclaimer-market-conduct',
      isSub: false,
    },
  ])
}
